import { Box } from '@mui/material'
import {
  Apps20Regular,
  Sparkle20Regular,
} from '@/components/Icon'
import HomeNavAutomationRows from './HomeNavAutomationRows'
import HomeNavPulseRow from './HomeNavPulseRow'
import HomeNavUpdatesSection from './HomeNavUpdatesSection'
import styles from './HomeNavPane.module.scss'

/** The Pulse half of the rail: automations, skills, and connected apps. */
export default function HomeNavPulsePane({
  workflows,
  schedule,
  schedulesActive,
  triggersActive,
  connectionsActive,
  skillsActive,
  onSchedules,
  onTriggers,
  onConnections,
  onSkills,
}) {
  return (
    <Box className={styles.pane}>
      <HomeNavAutomationRows {...{ triggersActive, schedulesActive, onTriggers, onSchedules }} />
      <Box className={styles.group}>
        <Box className={styles.sectionLabel}>Customize</Box>
        <HomeNavPulseRow
          Icon={Sparkle20Regular}
          label="Skills"
          active={Boolean(skillsActive)}
          onClick={onSkills}
        />
        <HomeNavPulseRow
          Icon={Apps20Regular}
          label="Connected apps"
          active={Boolean(connectionsActive)}
          onClick={onConnections}
        />
      </Box>
      <HomeNavUpdatesSection
        workflows={workflows}
        selectedScheduleId={schedule.selectedScheduleId}
        selectedScheduleKind={schedule.selectedScheduleKind}
        onSelectWorkflow={schedule.openSchedule}
      />
    </Box>
  )
}
